import { makeStyles, createStyles } from '@material-ui/core/styles';

const useCreditCardsHomeStyles = makeStyles(() => createStyles({
  ccHomeContainer: {
    width: '100%',
  },
}));

export default useCreditCardsHomeStyles;
